import { render, staticRenderFns } from "./champs.html?vue&type=template&id=15cab62c&scoped=true&external"
import script from "./champs.js?vue&type=script&lang=js&external"
export * from "./champs.js?vue&type=script&lang=js&external"
import style0 from "./champs.scss?vue&type=style&index=0&id=15cab62c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cab62c",
  null
  
)

export default component.exports